import styled from '@emotion/styled'
import 'jsoneditor/dist/jsoneditor.css'

const JsonEditorStyled = styled.div`
  width: 100%;
  height: 500px;
`

export default JsonEditorStyled
